import * as types from './mutation-types'

export default {
  [types.LOAD_CUSTOMER_STATUS](state, data) {
    state.customerStatus = data
  },
  [types.ADD_CUSTOMER_STAT] (state, data) {
    state.customerStatus.push(data)
  },
  [types.UPDATE_CUSTOMER_STAT] (state, data) {
    const index = state.customerStatus.findIndex(item => item.id === data.id)
    if (index !== -1) {
      state.customerStatus.splice(index, 1, data)
    }
  },
  [types.DELETE_CUSTOMER_STAT] (state, data) {
    state.customerStatus = state.customerStatus.filter(item => item.id !== data)
  },
}
